import React from 'react';
import './WorkshopCard.scss';
import { isExternalLink, safeHtml } from '../../services/helpers';
import CustomBtn from '../../components/CustomBtn/CustomBtn';
import StrapiImageWithSkeleton from '../StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function WorkshopCard({ workshop }) {

    return (
        <li className='workshop_card'>
            <StrapiImageWithSkeleton
                picture={workshop.Photo}
                loading="eager"
                fetchpriority='high'
                size='small'
                className='workshop_card__picture'
            />
            {
                workshop.withFreePatch &&
                <div
                    className={'workshop_card__free_patch'}
                >
                    GRATUIT
                </div>
            }
            <div className='workshop_card__content_container'>
                <h2 className='workshop_card__title'>
                    <span className='titre1'
                    >{workshop.Titre1}</span><br />
                    <span className='titre2'
                    >{workshop.Titre2}</span>
                </h2>
                <div className="workshop_card__content" dangerouslySetInnerHTML={safeHtml(workshop.Texte)} />
                <CustomBtn
                    type={
                        workshop.Bouton.LienBouton === null ? 'action'
                        :
                            isExternalLink(workshop.Bouton.LienBouton) ? 'external' : 'internal'
                    }
                    title={workshop.Bouton.TexteBouton}
                    link={
                        workshop.Bouton.LienBouton === null ?
                            ''
                        :
                            (isExternalLink(workshop.Bouton.LienBouton) ? 
                                workshop.Bouton.LienBouton
                            : 
                                '/' + workshop.Bouton.LienBouton)
                    }
                    bkg_color={'transparent'}
                    bkg_color_hover={'#EEE6DB'}
                    text_color={'#361215'}
                    text_color_hover={'#361215'}
                    border_color={'#361215'}
                    border_color_hover={'#361215'}
                    font_family={"Playfair Display, serif"}
                    font_size={'22px'}
                    font_weight={'bold'}
                    border_radius={'3px'}
                    padding={'5px 10px'}
                    width={'200px'}
                    margin={'10px 0'}
                />
            </div>
        </li>
    );
}